import { PaziaTab, PaziaTabs } from "components/atoms";
import { PageMain } from "components/molecules";
import { routes } from "consts";
import { Route, Routes } from "react-router-dom";
import { removeTrailingSlash } from "utils";
import { EmailTemplateParametersPage } from "./EmailTemplateParameters/EmailTemplateParametersPage";
import { EmailTemplatesPage } from "./EmailTemplates/EmailTemplatesPage";
import { AddEmailTriggerPage } from "./EmailTriggers/AddEmailTriggerPage";
import { EmailTriggersPage } from "./EmailTriggers/EmailTriggersPage";
import { ScheduledEmailForm } from "./ScheduledEmails/ScheduledEmailForm";
import { ScheduledEmailsPage } from "./ScheduledEmails/ScheduledEmailsPage";
import { ScheduledEmailViewPage } from "./ScheduledEmails/ScheduledEmailViewPage";
import { ScheduledMessageForm } from "./ScheduledMessages/ScheduledMessageForm";
import { ScheduledMessagesPage } from "./ScheduledMessages/ScheduledMessagesPage";
import { ScheduledMessageViewPage } from "./ScheduledMessages/ScheduledMessageViewPage";
import { TriggersEmailsPage } from "./TriggersEmails/TriggersEmailsPage";
import { EditEmailTriggerPage } from "./EmailTriggers/EditEmailTriggerPage";

const checkLocationPathName = (path: string) => {
  return removeTrailingSlash(location.pathname).includes(removeTrailingSlash(path));
};

export const EmailsPage = () => {
  const tabs: PaziaTab[] = [
    {
      name: "Emails",
      link: routes.EMAILS + routes.SCHEDULED_EMAILS,
      active: checkLocationPathName(routes.EMAILS + routes.SCHEDULED_EMAILS),
    },
    {
      name: "SMS",
      active: checkLocationPathName(routes.EMAILS + routes.SCHEDULED_MESSAGES),
      link: routes.EMAILS + routes.SCHEDULED_MESSAGES,
    },
    {
      name: "Systemowe",
      active: checkLocationPathName(routes.EMAILS + routes.EMAILS_HISTORY),
      link: routes.EMAILS + routes.EMAILS_HISTORY,
    },
    {
      name: "Zdarzenia",
      active: checkLocationPathName(routes.EMAILS + routes.EMAILS_TRIGGERS),
      link: routes.EMAILS + routes.EMAILS_TRIGGERS,
    },
    {
      name: "Szablony",
      active: checkLocationPathName(routes.EMAILS + routes.EMAILS_TEMPLATES),
      link: routes.EMAILS + routes.EMAILS_TEMPLATES,
    },
    {
      name: "Parametry",
      active: checkLocationPathName(routes.EMAILS + routes.EMAILS_TEMPLATE_PARAMETERS),
      link: routes.EMAILS + routes.EMAILS_TEMPLATE_PARAMETERS,
    },
  ];

  return (
    <PageMain>
      <PaziaTabs tabs={tabs} className="mb-6" />

      <Routes>
        <Route path={routes.SCHEDULED_EMAILS} element={<ScheduledEmailsPage />} />
        <Route path={routes.SCHEDULED_EMAILS_CREATE} element={<ScheduledEmailForm />} />
        <Route path={routes.SCHEDULED_EMAILS_EDIT()} element={<ScheduledEmailForm isEdit />} />
        <Route path={routes.SCHEDULED_EMAILS_VIEW()} element={<ScheduledEmailViewPage />} />

        <Route path={routes.SCHEDULED_MESSAGES} element={<ScheduledMessagesPage />} />
        <Route path={routes.SCHEDULED_MESSAGES_CREATE} element={<ScheduledMessageForm />} />
        <Route path={routes.SCHEDULED_MESSAGES_EDIT()} element={<ScheduledMessageForm isEdit />} />
        <Route path={routes.SCHEDULED_MESSAGES_VIEW()} element={<ScheduledMessageViewPage />} />

        <Route path={routes.EMAILS_HISTORY} element={<TriggersEmailsPage />} />

        <Route path={routes.EMAILS_TRIGGERS} element={<EmailTriggersPage />} />
        <Route path={routes.EMAILS_TRIGGERS_ADD} element={<AddEmailTriggerPage />} />
        <Route path={routes.EMAILS_TRIGGERS_EDIT()} element={<EditEmailTriggerPage />} />

        <Route path={routes.EMAILS_TEMPLATES} element={<EmailTemplatesPage />} />

        <Route path={routes.EMAILS_TEMPLATE_PARAMETERS} element={<EmailTemplateParametersPage />} />
      </Routes>
    </PageMain>
  );
};
